import { MUsers } from '@elte/translate-backend/interface/users';

import { Paginated } from '@feathersjs/feathers';
import { app, ServiceMethodsUsers } from './initialFethersjs';

export class UsersApi implements MUsers.IService {
    protected endPoint: ServiceMethodsUsers;

    constructor() {
        this.endPoint = app.service('users');
    }

    create(params: MUsers.UserData): Promise<MUsers.UserData> {
        return this.endPoint.create(params).then((value: MUsers.UserData) => {
            return value;
        });
    }

    find(): Promise<MUsers.UserData[]> {
        //todo: Poprawić typowanie
        //@ts-ignore
        return this.endPoint.find().then((value: Paginated<MUsers.UserData>) => value.data);
    }

    patch(id: string, params: MUsers.UserData): Promise<MUsers.UserData> {
        return this.endPoint.patch(id, params).then((value: MUsers.UserData) => value);
    }
}
